import React, { useState } from "react";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Flag } from "@phosphor-icons/react";
import { toast } from "sonner";

const REASONS = ["Spam ou publicidade", "Conteúdo ofensivo", "Discurso de ódio", "Fora do tópico", "Outro"];

// Report button + dialog for a comment or topic.
export default function ReportButton({ entityType, entityId, size = 14 }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(REASONS[0]);
  const [extra, setExtra] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit() {
    if (!user) { navigate("/login"); return; }
    setBusy(true);
    const finalReason = extra.trim() ? `${reason} — ${extra.trim()}` : reason;
    try {
      await api.post("/reports", { entity_type: entityType, entity_id: entityId, reason: finalReason });
      toast.success("Report enviado. Obrigado!");
      setOpen(false); setExtra("");
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  }

  return (
    <>
      <button onClick={() => setOpen(true)} className="text-zinc-500 hover:text-amber-400 p-1.5" title="Reportar" data-testid={`report-${entityType}-${entityId}`}>
        <Flag size={size} weight="bold" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#121217] border-white/10 text-white max-w-md" data-testid="report-dialog">
          <DialogHeader><DialogTitle className="font-display text-xl flex items-center gap-2"><Flag size={18} weight="fill" className="text-amber-400" /> Reportar</DialogTitle></DialogHeader>
          <div className="space-y-3 mt-2">
            <div className="space-y-1.5">
              {REASONS.map((r) => (
                <button key={r} onClick={() => setReason(r)} className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${reason === r ? "bg-[#E63946]/15 text-white border border-[#E63946]/40" : "bg-[#1C1C22] text-zinc-300 border border-white/5 hover:bg-white/5"}`} data-testid={`report-reason-${r}`}>
                  {r}
                </button>
              ))}
            </div>
            <Textarea rows={2} value={extra} onChange={(e) => setExtra(e.target.value)} placeholder="Detalhes (opcional)" className="bg-[#1C1C22] border-white/10" data-testid="report-extra-input" />
            <Button onClick={submit} disabled={busy} className="btn-crimson w-full" data-testid="report-submit-btn">
              {busy ? "A enviar..." : "Enviar report"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
